// extracted by mini-css-extract-plugin
module.exports = {"container":"_1fdINySS4tvDs7hmd3QgEp","newDishModificationFields":"_17akVMPyuk70m-vj8WaM61"};